<template>
  <SiteMenuFlyoutLayout @close="$emit('close')">
    <div class="mb-8">
      <a class="text-lg" href="/">Our Difference</a>
    </div>
    <div class="grid grid-cols-6 gap-ogs-large">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="col-span-3 md:col-span-2"
      >
        <a class="block" :href="item.url">
          <div class="h-0 pt-full relative mb-4">
            <img
              v-if="item.image.length"
              :src="item.image[0].url"
              :alt="item.image[0].title"
              class="absolute inset-0 w-full h-full object-cover"
            />
            <div v-else class="absolute inset-0 w-full h-full bg-grey"></div>
          </div>
          <h3 class="text-md">{{ item.title }}</h3>
        </a>
      </div>
    </div>
  </SiteMenuFlyoutLayout>
</template>

<script>
import SiteMenuFlyoutLayout from "./SiteMenuFlyoutLayout.vue";

export default {
  name: "SiteMenuFlyoutAbout",
  components: {
    SiteMenuFlyoutLayout,
  },
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
};
</script>
